import { GetPrestacionesApi } from "../../../../../services/SiniestrosEmpresa";

import {
  GetDraftDocument, CreateDraftDocuments, DeleteDraftComplaint, UpdateDraftDocument,
  doUploadDocumentApi, doGetUploadDraftDocumentApi, doDeleteFileApi, doDeleteContainerApi, sendDraftApi, GetPrestacionEconomicaPDFApi, MovePrestacionesFiles,
} from "../../../../../services/PrestacionesEconomicasApi";

import { formatDateForFilter } from "../../../../../helpers/dateFormat";

import { openCloseToast } from "../../../../Global/actions";
import { getUserInfo } from "../../../../../services/misDatosApi";
import validaciones from "../../../../../helpers/validaciones";
import { filterData } from "../../../../../helpers/filterHelper";
import { store } from "../../../../../config/store";
import trace from "../../../../../helpers/trace";
import { filterType } from "../../../../../helpers/filterHelper";
import { showFile } from "../../../../Pdf/actions";


const Moment = require("moment");
export const loading = (isLoading) => ({
  type: "LOADING_PRESTACIONES_EMPRESA",
  isLoading,
});

export const resetStatePrestacionesEmpresa = () => ({
  type: "RESET_STATE_PRESTACIONES_EMPRESA",
});

export const setPrestacionesEmpresa = (listaPrestaciones, total) => ({
  type: "SET_PRESTACIONES_EMPRESA",
  listaPrestaciones,
  total,
});
export const setPrestacionesEmpresaFiltradas = (listaPrestacionesFiltrada) => ({
  type: "SET_PRESTACIONES_EMPRESAS_FILTRADAS",
  listaPrestacionesFiltrada,
});

export const setPrestacionesFilters = (filtros) => ({
  type: "SET_PRESTACIONES_FILTERS",
  filtros,
});

export const setTipoPrestacion = (tipo) => ({
  type: "SET_TIPO_PRESTACION",
  tipo,
});
export const setCleanDataDraft = () => ({
  type: "SET_CLEAN_DATA_DRAFT",
});
export const openCloseModalBorrador = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_BORRADOR_PE",
  isOpen,
});
export const openCloseModalContinue = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_CONTINUE",
  isOpen,
});
export const openCloseModalDelete = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_DELETE",
  isOpen,
});
export const editingDraft = (editing) => ({
  type: "EDITING_DRAFT_PE",
  editing,
});

export const setStep = (step) => ({
  type: "SET_STEP_PE",
  step,
});
export const setShowNoData = (showNoData) => ({
  type: "SET_SHOW_NO_DATA",
  showNoData,
});
export const setShowHideForm = (showHideForm) => ({

  type: "SET_SHOWHIDE_FORM_PE",
  showHideForm,
});

export const setDataForms = (jsonData) => ({
  type: "SET_JSON_DATA_PE",
  jsonData,
});

export const setMainFilterSelected = (item) => (dispatch) => {
  dispatch({
    type: 'SET_MAIN_FILTER_SELECTED', //tipo de caso
    payload: item // data a actualizar o nuevo estado
  })
}

export const setListaPrestacionFromBorrador = (jsonData) => ({
  type: "SET_LISTA_PRESTACION_FROM_BORRADOR",
  jsonData,
});

export const nextStep = () => ({
  type: "NEXT_STEP_PE",
});

export const lastStep = () => ({
  type: "LAST_STEP_PE",
});

export const setDraft = (jsonData) => ({
  type: "SET_DRAFT_PE",
  jsonData,
});

export const setIdDraft = (IdDraft) => ({
  type: "SET_ID_DRAFT_PE",
  IdDraft,
});

export const setDocumentList = (listaDocumentosIngresados) => ({
  type: "SET_DOCUMENT_LIST",
  listaDocumentosIngresados,
});

export const setMainFilters = (mainFilters) => ({
  type: "SET_MAIN_FILTERS",
  mainFilters,
});

export const setIsDownloadExcel = (isDownloadLoading) => ({
  type: "LOADING_PRESTACIONES_DOWNLOAD_EXCEL",
  isDownloadLoading,

});

export const getListaPrestaciones = (data, firstLoad) => async (dispatch) => {
  const { companyId, sucursalId, userData } = store.getState().global;
  const filtros = {
    RutEmpresa: companyId,
    RutUsuario: userData.RUT,
    Pagina: 1,
    RegistrosPorPagina: 100000,
    FechaDesde: data.from,
    FechaHasta: data.to,

  };
  if (validaciones.emptyText(sucursalId)) {
    filtros.idSucursal = sucursalId;
  }
  dispatch(doGetFinancialbenefits(filtros, firstLoad));
}


export const doGetFinancialbenefits = (filtros, firstLoad) => async (dispatch) => {
  dispatch(loading(true));

  try {
    const request = await GetPrestacionesApi(filtros);
    if (request.status === 200) {
      const result = await request.json();
      const pivot = result.PrestacionesEconomicas;
      pivot.forEach((r) => {
        result.PrestacionesEconomicas.FechaSiniestro = new Date(Moment(r.FechaSiniestro, "DD/MM/YYYY").format("MM/DD/YYYY"));
      });

      // .sort((a, b) => new Date(b.FechaSiniestro) - new Date(a.FechaSiniestro))
      dispatch(setPrestacionesEmpresa(pivot, result.TotalRegistros));
      dispatch(doGetPrestacionesFilters(pivot));

      if (firstLoad === true) {
        const currentFilters = [
          {
            column: "EstadoDocumentacion", value: { text: "Sin Documentacion", value: "Sin Documentacion" },
          },
        ];
        const newData = filterData(pivot, currentFilters);

        // 16833634-9 /00684343
        dispatch(setPrestacionesEmpresaFiltradas(newData));
      } else {
        dispatch(setPrestacionesEmpresaFiltradas(pivot));
      }


      result.PrestacionesEconomicas.length === 0 && dispatch(setShowNoData(true));
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(loading(false));
};


export const doGetDraft = (data) => async (dispatch) => {
  dispatch(loading(true));
  const toast = {};
  try {
    const request = await GetDraftDocument(data.employeeRut, data.companyRut, data.userRut, data.idFinancialBenefit);
    if (request.status === 200) {
      let form = {};
      let infoUser = {};
      const result = await request.json();

      if (result.FinancialBenefit) {
        form = JSON.parse(result.FinancialBenefit.JsonData);
        form.Id = result.FinancialBenefit.Id;
        form.idSiniestro = data.idSiniestro;
        form.companyRut = data.companyRut;
        form.formInfoTrabajador.idTipoPrestacion = data.IdTipoPrestacion;
        form.formInfoTrabajador.tipoPrestacion = data.TipoPrestacion;

        if (data.estadoObjetado) form.currentStep = 1;

        dispatch(setDraft(form));
        dispatch(setStep(form.currentStep));
         dispatch(editingDraft(true));
         if (data.estadoObjetado) {
           dispatch(setShowHideForm(true));
        } else {
          dispatch(openCloseModalContinue(true));
         }

        const rutWorker = validaciones.formatRut(data.employeeRut, { showDots: false, showHyphen: true });
        const dataDcto = {
          rutUsuario: data.userRut,
          rutTrabajador: rutWorker,
          idPrestacion: data.idFinancialBenefit,
        };
        dispatch(doGetDocuements(dataDcto));
      } else {
        // NEW DRAFT
        const responseGetUser = await getUserInfo(data.employeeRut);
        const resultGetUser = await responseGetUser.json();
        const newJsonData = { ...data.jsonData };
        let Bank = null;
        let AccountType = null;
        let AccountNumber = null;
        let FormaPago = null;
        if (responseGetUser.status === 200) {
          if (resultGetUser.Success) {
            Bank = resultGetUser.Profile.Payment.Bank.Description;
            AccountType = resultGetUser.Profile.Payment.AccountType.Description;
            AccountNumber = resultGetUser.Profile.Payment.AccountNumber;
            FormaPago = resultGetUser.Profile.Payment.Bank.Description ? "Transferencia electrónica" : null;
          }
        } else {
          console.log("error...", result.Message);
        }
        newJsonData.fechaSiniestro = data.fechaSiniestro;
        newJsonData.idSiniestro = data.idSiniestro;
        newJsonData.companyRut = data.companyRut;
        newJsonData.BpSucursal = data.BpSucursal;
        newJsonData.IsNew = data.IsNew;
        newJsonData.idFinancialBenefit = data.idFinancialBenefit;
        newJsonData.fechaInicioUltimoReposo = data.fechaInicioUltimoReposo;
        infoUser = {
          Rut: validaciones.formatRut(data.employeeRut, { showDots: true, showHyphen: true }),
          FirstName: `${data.FirstName} ${data.SecondName}`,
          LastName: `${data.LastName}  ${data.MotherName}`,
          Bank,
          AccountType,
          AccountNumber,
          FormaPago,
          // email: null,
          // fechaContrato: null,
          TipoPrestacion: data.TipoPrestacion,
          IdTipoPrestacion: data.IdTipoPrestacion
        };

        newJsonData.formInfoPrevisional = {
          checkAllMonth: false,
        };
        newJsonData.formInfoTrabajador = {
          ...infoUser,
        };
        dispatch(setStep(1));
        dispatch(setShowHideForm(true));
        dispatch(setDataForms(newJsonData));
      }
    }
    if (request.status === 500) {
      toast.isToastOpen = true;
      toast.msgToast = "Error de conexión, intente mas tarde";
      toast.typeStyle = "error";
      toast.displayTime = 5000;
      dispatch(openCloseToast(toast));
    }
  } catch (error) {
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente mas tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

export const doCreateDraft = (Data, showNotification) => async (dispatch) => {
  if (showNotification) dispatch(loading(true));
  const toast = {};
  try {
    const request = await CreateDraftDocuments(Data);
    if (request.status === 200) {
      const result = await request.json();
      if (result.Id) {
        const { jsonData } = store.getState().prestacionesEmpresa;
        jsonData.Id = result.Id;
        dispatch(setDataForms(jsonData));
        //dispatch(setListaPrestacionFromBorrador(jsonData, 'Borrador'));
      }
      if (showNotification) {
        toast.isToastOpen = true;
        toast.msgToast = "Creación de borrador realizada";
        toast.typeStyle = "success";
        toast.displayTime = 5000;
        dispatch(openCloseToast(toast));
        dispatch(setCleanDataDraft());
        dispatch(setShowHideForm(false));
        dispatch(openCloseModalBorrador(false));
        // dispatch(setIdDraft())
      }
    }
    if (request.status === 500) {
      if (showNotification) {
        toast.isToastOpen = true;
        toast.msgToast = "Error de conexión, intente mas tarde";
        toast.typeStyle = "error";
        toast.displayTime = 5000;
        dispatch(openCloseToast(toast));
      }
    }
  } catch (error) {
    console.log(error);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente mas tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
  if (showNotification) dispatch(loading(false));
};


export const doUpdateDraft = (Data, showNotification) => async (dispatch) => {
  if (showNotification) dispatch(loading(true));
  try {
    const request = await UpdateDraftDocument(Data);
    if (request.status === 200) {
      // const { jsonData } = store.getState().prestacionesEmpresa;
      if (showNotification) {
        dispatch(openCloseToast({
          isToastOpen: true,
          msgToast: "Borrador actualizado",
          typeStyle: "success",
          displayTime: 5000
        }));

        dispatch(setCleanDataDraft());
        dispatch(setShowHideForm(false));
        dispatch(openCloseModalBorrador(false));
        // dispatch(setListaPrestacionFromBorrador(jsonData));
      }
    } else if (showNotification) {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión, intente mas tarde",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente mas tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  if (showNotification) dispatch(loading(false));
};

export const doDeleteDraft = (IdDraftFinancialBenefit, data) => async (dispatch) => {
  dispatch(loading(true));
  try {
    if (IdDraftFinancialBenefit) {
      const request = await DeleteDraftComplaint(IdDraftFinancialBenefit);
      if (request.status === 200) {
        if (data) {
          const requestConatiner = await doDeleteContainerApi(data);
          if (requestConatiner.status === 200) {
            dispatch(openCloseToast({
              isToastOpen: true,
              msgToast: "Borrador y documentos eliminados",
              typeStyle: "success",
              displayTime: 5000
            }));
          }
        } else {
          dispatch(openCloseToast({
            isToastOpen: true,
            msgToast: "Borrador Eliminado",
            typeStyle: "success",
            displayTime: 5000
          }));
        }

        dispatch(setCleanDataDraft());
        dispatch(setShowHideForm(false));
        dispatch(openCloseModalBorrador(false));
      } else {
        dispatch(openCloseToast({
          isToastOpen: true,
          msgToast: "Error de conexión, intente mas tarde",
          typeStyle: "error",
          displayTime: 5000
        }));
      }
    } else {
      dispatch(setCleanDataDraft());
      dispatch(setShowHideForm(false));
      dispatch(openCloseModalBorrador(false));
    }
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doGetDocuements = (data) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await doGetUploadDraftDocumentApi(data.rutUsuario, data.rutTrabajador, data.idPrestacion);
    if (request.status === 200) {
      const result = await request.json();
      const lista = [];

      if (result.ListaDocumentos && result.ListaDocumentos.length > 0) {
        result.ListaDocumentos.forEach((element) => {
          lista.push({
            Nombre: element.Nombre.replace(/%20/g, " "),
            Uri: element.Uri,
            tipo: element.tipo,
          });
        });
        dispatch(setDocumentList(lista));
      }
    }
  } catch (e) {
    console.error("doGetDocuements", e);
  }
  dispatch(loading(false));
};

export const doUploadFile = (data, resultCallback) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const newFile = new FormData();

    newFile.append("files", data.files);
    newFile.append("rutTrabajador", data.rutTrabajador);
    newFile.append("rutUsuario", data.rutUsuario);
    newFile.append("idPrestacion", data.idPrestacion);
    if (data.type) newFile.append("type", data.type);
    const response = await doUploadDocumentApi(newFile);
    if (response.status === 200) {
      dispatch(doGetDocuements({
        rutTrabajador: data.rutTrabajador,
        rutUsuario: data.rutUsuario,
        idPrestacion: data.idPrestacion,
      }));
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Documento ingresado",
        typeStyle: "success",
        displayTime: 5000
      }));
      if (resultCallback) resultCallback();
    } else if (response.status == 413) {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "El archivo es muy grande",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doDeleteSingleFile = (data, showNotification) => async (dispatch) => {
  if (showNotification) dispatch(loading(true));
  try {
    const request = await doDeleteFileApi(data);
    if (request.status === 200) {
      if (showNotification) {
        dispatch(doGetDocuements({
          rutTrabajador: data.rutTrabajador,
          rutUsuario: data.rutUsuario,
          idPrestacion: data.idPrestacion,
        }));
        dispatch(openCloseToast({
          isToastOpen: true,
          msgToast: "Documento Eliminado",
          typeStyle: "success",
          displayTime: 5000
        }));
      }
    }
  } catch (e) {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  if (showNotification) dispatch(loading(false));
};

export const doGetPrestacionesFilters = (PrestacionesEconomicas) => async (dispatch) => {
  try {
    const mainFilters = [];


    let TipoPrestacion = PrestacionesEconomicas.map((item) => ({ text: item.TipoPrestacion, value: item.TipoPrestacion }));
    TipoPrestacion = validaciones.getUnique(TipoPrestacion, "text");

    let EstadoDocumentacion = PrestacionesEconomicas.map((item) => ({ text: item.EstadoDocumentacion, value: item.EstadoDocumentacion }));
    EstadoDocumentacion = validaciones.getUnique(EstadoDocumentacion, "text");

    EstadoDocumentacion.forEach((item) => {
      let Icon = "S";
      let index = 0;
      switch (item.text) {
        case "Sin Documentacion": {
          Icon = "2";
          index = 1;
          break;
        }
        case "Objetado": {
          Icon = "6";
          index = 2;
          break;
        }
        case "Cert Fisico": {
          Icon = "1";
          index = 3;
          break;
        }
        case "Revision ACHS": {
          Icon = "5";
          index = 4;
          break;
        }
        case "Aceptado": {
          Icon = "X";
          index = 5;
          break;
        }
        default:
          break;
      }


      mainFilters.push({
        index,
        Icon,
        name: item.text,
        column: "EstadoDocumentacion",
        value: { text: item.text, value: item.text },
        filterValue: "IdEstadoDocumentacion",
        showName: false
      });

    });

    mainFilters.push({
      index: 6, Icon: "0", name: "Todas las prestaciones", column: "estadoDocumentacion", value: { text: "TODAS", value: "TODAS" },
    });

    let EstadoPago = PrestacionesEconomicas.map((item) => ({ text: item.EstadoPago, value: item.EstadoPago }));
    EstadoPago = validaciones.getUnique(EstadoPago, "text");

    const filters = [
      {
        column: "FechaSiniestro", filterValue: "IdFechaSiniestro", name: "Fecha siniestro", type: filterType.date, max: new Date(), oneYearInterval: true, showName: false
      },
      {
        column: "TipoPrestacion", name: "Tipo prestacion", values: TipoPrestacion, showName: false,
      }
    ];

    dispatch(setPrestacionesFilters(filters));
    dispatch(setMainFilters(mainFilters.sort((a, b) => a.index - b.index)));
  } catch (e) {
    console.error(e);
  }
};


export const doSendPrestacionEconomica =  (data, userRut) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const requestData = {
      idSiniestro: data.idSiniestro,
      RutEmpresa: data.companyRut,
      idPrestacion: data.idFinancialBenefit,
      BpSucursal: data.BpSucursal,
      IsNew: data.IsNew,
      Periodos: data.monthsDate,
      FechaSiniestro: data.fechaSiniestro,
      FechaInicioUltimoReposo: data.fechaInicioUltimoReposo,
      FinancialBenefitType: data.FinancialBenefitType,
      formInfoTrabajador: {
        Rut: data.formInfoTrabajador.Rut,
        FirstName: data.formInfoTrabajador.FirstName,
        LastName: data.formInfoTrabajador.LastName,
        Bank: data.formInfoTrabajador.Bank,
        // AccountNumber: data.formInfoTrabajador.AccountNumber || 0,
        AccountNumber: data.formInfoTrabajador.AccountNumber,
        FormaPago: data.formInfoTrabajador.FormaPago[0],
        email: data.formInfoTrabajador.email,
        FechaContrato: data.formInfoTrabajador.fechaContrato,
        AccountType: data.formInfoTrabajador.AccountType,
      },
      formInfoLaboral: {
        DiasTrabajadosMesUno: data.formInfoLaboral.DiasTrabajadosMesUno,
        DiasTrabajadosMesDos: data.formInfoLaboral.DiasTrabajadosMesDos,
        DiasTrabajadosMesTres: data.formInfoLaboral.DiasTrabajadosMesTres,
      },
      formInfoPrevisional: {
        afpMesUno: data.formInfoPrevisional.afpMesUno,
        codigoPrevisionMesUno: data.formInfoPrevisional.codigoPrevisionMesUno,
        valorPlanMesUno: data.formInfoPrevisional.valorPlanMesUno,
        unidadMesUno: data.formInfoPrevisional.unidadMesUno,

        afpMesDos: data.formInfoPrevisional.afpMesDos,
        codigoPrevisionMesDos: data.formInfoPrevisional.codigoPrevisionMesDos,
        valorPlanMesDos: data.formInfoPrevisional.valorPlanMesDos,
        unidadMesDos: data.formInfoPrevisional.unidadMesDos,

        afpMesTres: data.formInfoPrevisional.afpMesTres,
        codigoPrevisionMesTres: data.formInfoPrevisional.codigoPrevisionMesTres,
        valorPlanMesTres: data.formInfoPrevisional.valorPlanMesTres,
        unidadMesTres: data.formInfoPrevisional.unidadMesTres,
      },
    };
    const request = await sendDraftApi(requestData);
    if (request.status === 200) {
      const result = await request.json();
      const rutTrabajador = validaciones.formatRut(data.formInfoTrabajador.Rut, { showDots: false, showHyphen: true });

      const moveRequest = await MovePrestacionesFiles(result.IdPrestacion, rutTrabajador, userRut, data.idSiniestro, data.IsNew)

      dispatch(setShowHideForm(false));
      dispatch(setCleanDataDraft());
      dispatch(getListaPrestaciones({
        from: formatDateForFilter(Moment().subtract(1, "year")),
        to: formatDateForFilter(Moment()),
      }, false));
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Prestacion enviada",
        typeStyle: "success",
        displayTime: 5000
      }));
    }
  } catch (e) {
    trace.error("doSendPrestacionEconomica", e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
  const selectOption = {
    index: 6, Icon: "0", name: "Todas las prestaciones", column: "estadoDocumentacion", value: { text: "TODAS", value: "TODAS" }
  }
  dispatch(setMainFilterSelected(selectOption));
};

export const doGetPrestacionEconomicaPDF = (idSiniestro, NombreTrabajador, rutTrabajador) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await GetPrestacionEconomicaPDFApi(idSiniestro, NombreTrabajador, rutTrabajador);
    if (request.status === 200) {
      const doc = await request.blob();
      showFile(doc);
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al obtener el PDF, intentelo nuevamente",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    console.error("doGetPrestacionEconomicaPDF", e);
  }
  dispatch(loading(false));
}
